import {
  ArticleDetailsFragment,
  AudioDetailsFragment,
  VideoDetailsFragment,
} from '../../graphql/types';
import { AudioPlayer } from './AudioPlayer';
import WistiaPlayer from './WistiaPlayer';

interface ContentViewerProps {
  content:
    | AudioDetailsFragment
    | VideoDetailsFragment
    | ArticleDetailsFragment
    | null;
}
export const ContentViewer = ({ content }: ContentViewerProps) => {
  if (content?.__typename === 'Video') {
    return <WistiaPlayer content={content} />;
  }

  if (content?.__typename === 'Audio') {
    return <AudioPlayer content={content} />;
  }

  return null;
};
